<template>
  <div class="coupon-rules">
    这个是优惠卷使用规则
  </div>
</template>

<script>
  export default {
    name: 'coupon-rules'
  }
</script>

<style lang="less" scoped>
.coupon-rules {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>